import React from 'react';
import { useHistory } from 'react-router-dom';

import { locale } from '@trqk/utils';
import { Button, IconInfoCircle, WarningModalBody } from '@trqk/components';

import { useManageDetectionsLocation } from '../../../hooks';

/**
 * Modal content that prompts the user to enable detection. Shown when the user has a payment plan
 * that includes detection capacity and has uploaded one or more audio files, but has not enabled
 * detection on any audio files.
 */
export const EnableDetectionReminderContent = ({
    remove,
}: ModalContentProps<Record<string, never>>): JSX.Element => {
    const history = useHistory();
    const location = useManageDetectionsLocation();

    return (
        <WarningModalBody height={420} width={800}>
            <div className="flex flex-col h-full justify-between">
                <h5 className="flex-none text-quinary-700 mt-2">
                    {locale.enUS.ENABLE_DETECTION_REMINDER.TITLE}
                </h5>
                <p className="flex-none mt-8">
                    {locale.enUS.ENABLE_DETECTION_REMINDER.BODY.PART_1}
                </p>
                <div
                    className="flex-grow grid items-start mt-8"
                    style={{ gridTemplateColumns: '30px auto' }}
                >
                    <IconInfoCircle fillColor="primary-500" addClasses="mr-2" />
                    <p className="italic text-tertiary-400">
                        {locale.enUS.ENABLE_DETECTION_REMINDER.BODY.PART_2}
                    </p>
                </div>

                <div className="flex-none">
                    <Button
                        color="primary-light-bg"
                        autoWidth={true}
                        handleClick={(): void => {
                            remove({
                                canceled: false,
                                success: true,
                            });

                            setTimeout(() => {
                                history.push(location);
                            }, 500);
                        }}
                    >
                        {locale.enUS.ENABLE_DETECTION_REMINDER.ENABLE_DETECTION}
                    </Button>
                </div>
            </div>
        </WarningModalBody>
    );
};
